module.exports = __webpack_public_path__ + "static/media/home-background.85f82a6a.png";